import React from "react";
import PropTypes from "prop-types";
import formatter from "../../../utils/formatter";
import { SummaryLabel, SummaryData } from "../../commonStyles";

const PageAccountSummary = ({ dataName, label, value, themeColor }) => (
  <>
    <SummaryLabel
      isWordBreak={dataName === "accountName"}
      themeColor={themeColor}
    >
      {label}
    </SummaryLabel>

    {dataName === "accountName" ? (
      <SummaryData themeColor={themeColor}>{value}</SummaryData>
    ) : (
      <SummaryData themeColor={themeColor}>
        {formatter({ value, fieldSuffix: "Dollars" })}
      </SummaryData>
    )}
  </>
);

PageAccountSummary.propTypes = {
  dataName: PropTypes.string,
  label: PropTypes.string,
  themeColor: PropTypes.string,
  value: PropTypes.string
};

export default PageAccountSummary;
